import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PARTNER_SCOPED,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_RECEIPTS = `${URL_RETAILER_SCOPED}/receipts`
const URL_RECEIPTS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/receipts`
const URL_RECEIPTS_LIST = `${URL_RECEIPTS_PARTNER_SCOPED}/list`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'receipts' | 'receipts-partner-scoped' | 'receipts-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  receipts: URL_RECEIPTS,
  'receipts-partner-scoped': URL_RECEIPTS_PARTNER_SCOPED,
  'receipts-list': URL_RECEIPTS_LIST,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
